import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyWaitModule } from '../wait';
import { SkyGridModule } from '../grid';
import { SkyListViewGridComponent } from './list-view-grid.component';


export class SkyListViewGridModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyListViewGridComponent
  ],
  imports: [
    CommonModule,
    SkyWaitModule,
    SkyGridModule
  ],
  exports: [
    SkyListViewGridComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
